import { useMutation } from '@tanstack/react-query';
import { postData } from '../../utils/api';
import { API_ROUTES } from '../../constants/apiRoutes';
import { PaymentAuthResult } from '../../types/payment';
import { usePaymentResponseHandler } from '../usePaymentResponseHandler';
import { cryptoPaymentProviders } from '../../config/payment/crypto';

type CryptoDepositPayload = Record<string, never>;

export type CryptoDepositResponse = {
  address: string;
};

export type CryptoWithdrawPayload = {
  amount: string;
  address: string;
};

type CryptoWithdrawResponse = {
  authResults?: PaymentAuthResult[];
  userId?: string;
  marketplaceId?: string;
  amount?: string;
  address?: string;
};

export const useCrypto = () => {
  const { handlePaymentSuccess, handlePaymentError } = usePaymentResponseHandler();

  const depositMutation = useMutation<CryptoDepositResponse, Error, CryptoDepositPayload>({
    mutationFn: (data) => postData(API_ROUTES.CRYPTO.DEPOSIT, data, 'wallet'),
    onError: (error) => {
      handlePaymentError(error, {
        failureMessage: 'depositRequestFailed',
      });
    },
  });

  const withdrawMutation = useMutation<CryptoWithdrawResponse, Error, CryptoWithdrawPayload>({
    mutationFn: (data) => postData(API_ROUTES.CRYPTO.WITHDRAW, data, 'wallet'),
    onSuccess: (response) => {
      handlePaymentSuccess(response, {
        successMessage: 'withdrawRequestSubmitted',
      });
    },
    onError: (error) => {
      handlePaymentError(error, {
        failureMessage: 'withdrawRequestFailed',
      });
    },
  });

  return { depositMutation, withdrawMutation, paymentProviders: cryptoPaymentProviders };
};
